import { render, staticRenderFns } from "./FormTestimonial.vue?vue&type=template&id=1a4dc2ae&"
import script from "./FormTestimonial.vue?vue&type=script&lang=js&"
export * from "./FormTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports